module.exports = __webpack_public_path__ + "static/media/carletonCampus_lineDrawing.d61f368b.png";